import { render, staticRenderFns } from "./UpdateFutures.vue?vue&type=template&id=2802e8c0&scoped=true"
import script from "./UpdateFutures.vue?vue&type=script&lang=js"
export * from "./UpdateFutures.vue?vue&type=script&lang=js"
import style0 from "./UpdateFutures.vue?vue&type=style&index=0&id=2802e8c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2802e8c0",
  null
  
)

export default component.exports